import React from 'react';
import Reporting from "../../../GroupReporting/Reporting";

const ReportSettingsTabContent = (props) => {
  return (
    <Reporting />
  )
};

export default ReportSettingsTabContent;